module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/uses.json
// module id = 340
// module chunks = 111194303327527